// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Define the margin-top for small screens */
.account_fillbtnsmallscreen__1FFC- {
    margin-top: 0;
    /* Add the desired margin for small screens */
}


/* Media query to remove the margin on larger screens */
@media (min-width: 992px) {
    .account_fillbtnsmallscreen__1FFC- {
        margin-top: 30px;
        /* Remove the margin on larger screens */
    }

  
}

@media (min-height: 992px) {

    /* Adjust scroll height for large screens (lg and up) */
    .account_customtable__7a5pj {
        max-height: 600px;
    }
}`, "",{"version":3,"sources":["webpack://./src/component/pagesComponent/account.module.css"],"names":[],"mappings":"AAAA,4CAA4C;AAC5C;IACI,aAAa;IACb,6CAA6C;AACjD;;;AAGA,uDAAuD;AACvD;IACI;QACI,gBAAgB;QAChB,wCAAwC;IAC5C;;;AAGJ;;AAEA;;IAEI,uDAAuD;IACvD;QACI,iBAAiB;IACrB;AACJ","sourcesContent":["/* Define the margin-top for small screens */\r\n.fillbtnsmallscreen {\r\n    margin-top: 0;\r\n    /* Add the desired margin for small screens */\r\n}\r\n\r\n\r\n/* Media query to remove the margin on larger screens */\r\n@media (min-width: 992px) {\r\n    .fillbtnsmallscreen {\r\n        margin-top: 30px;\r\n        /* Remove the margin on larger screens */\r\n    }\r\n\r\n  \r\n}\r\n\r\n@media (min-height: 992px) {\r\n\r\n    /* Adjust scroll height for large screens (lg and up) */\r\n    .customtable {\r\n        max-height: 600px;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fillbtnsmallscreen": `account_fillbtnsmallscreen__1FFC-`,
	"customtable": `account_customtable__7a5pj`
};
export default ___CSS_LOADER_EXPORT___;
